import cx from 'classnames'
import styles from './RequestedProvider.module.css'
import { type AvatarSubject, Avatar } from '@/components/Avatar'
import { Tooltip } from '@/components/Tooltip'
import { truncate } from 'lodash-es'
import {
  Dropdown,
  DropdownItem,
  DropdownItemTitle,
  DropdownTitle,
} from '@/components/Dropdown'
import { IconButton } from '@/components/IconButton'
import { Icon } from '@/components/Icon'

export interface RequestedProviderProps {
  displayName: string
  email: string
  phone: string
  isOnline: boolean
  avatar: AvatarSubject
  canViewActionsMenu: boolean
  onRemove: () => void
}

export function RequestedProvider({
  displayName,
  email,
  phone,
  isOnline,
  avatar,
  canViewActionsMenu,
  onRemove,
}: RequestedProviderProps) {
  return (
    <div
      className={cx(
        styles.root,
        email && styles.withEmail,
        phone && styles.withPhone,
      )}
    >
      <div className={styles.info}>
        <div className={styles.header}>
          <p className={styles.title}>{displayName}</p>

          {canViewActionsMenu && (
            <Dropdown
              autoDismiss
              testId="collaborators-card-requested-provider-dropdown-menu"
              button={
                <IconButton
                  name="more"
                  label="Requested provider actions"
                  rotate={90}
                />
              }
            >
              <DropdownTitle>Actions</DropdownTitle>

              <DropdownItem
                icon={<Icon name="delete" />}
                onPress={onRemove}
                testId="collaborators-remove-requested-pro-dropdown-item"
              >
                <DropdownItemTitle>Remove provider</DropdownItemTitle>
              </DropdownItem>
            </Dropdown>
          )}
        </div>

        <div className={styles.subtitle}>
          <div className={styles.subtitleInfo}>
            {email && (
              <>
                {email.length >= 38 ? (
                  <Tooltip content={email}>
                    <p className={styles.email}>
                      {truncate(email, { length: 38 })}
                    </p>
                  </Tooltip>
                ) : (
                  <p className={styles.email}>{email}</p>
                )}
              </>
            )}
            {phone && <p className={styles.phone}>{phone}</p>}
          </div>
        </div>
        <div className={styles.footer}>
          <p>
            <span className={styles.pro}>Requested Provider</span>
          </p>

          <div className={styles.avatarContainer}>
            <Avatar
              badge={isOnline ? 'online' : 'offline'}
              size={32}
              subject={avatar}
            />
          </div>
        </div>
      </div>
    </div>
  )
}
